import PageBanner from "@/components/PageBanner";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "What olive oil profiles do you work with?", a: "We mainly work with Chemlali, Chetoui, Lampante and custom Chemlali/Chetoui blends depending on buyer requirements and intended market use." },
  { q: "Do you work with blends?", a: "Yes. We develop custom Chemlali / Chetoui blends based on the buyer's target profile, price positioning and commercial objective." },
  { q: "Do you supply Lampante?", a: "Yes. We supply Lampante olive oil in bulk for refiners, processors and industrial buyers." },
  { q: "Do you work in bulk?", a: "Yes. MM2A is fully oriented toward professional bulk supply rather than retail orders." },
  { q: "Do you export internationally?", a: "Yes. We work with buyers across Europe, Asia, the Americas and other international markets." },
  { q: "What is your supply capacity?", a: "We currently handle over 8,000 tonnes per year and continue to grow through our sourcing network and long-term buyer relationships." },
  { q: "Can you send samples?", a: "Yes. Sample evaluation is a standard part of our commercial process before final alignment." },
  { q: "Do you have a fixed MOQ?", a: "Minimum order quantity depends on the product profile, required format, target market and commercial structure." },
  { q: "Who do you work with?", a: "We work with importers, bottlers, distributors, refineries, industrial processors, food manufacturers and other professional buyers." },
  { q: "How can I request product information or samples?", a: "You can contact us through the website contact form, by email or directly via WhatsApp. We reply within 24 hours." },
  { q: "What Incoterms do you work with?", a: "We work primarily on FOB ,Exworks and CIF are available depending on destination and volume. Contact us to discuss the most suitable option for your project." },
];

const FAQ = () => {
  return (
    <div>
      <PageBanner title="Frequently Asked Questions" />

      <section className="section-padding">
        <div className="container-max max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-card border border-border rounded-lg px-6">
                <AccordionTrigger className="font-heading text-lg font-semibold text-foreground hover:no-underline">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
